import { render, staticRenderFns } from "./DeliverAddGoodTable.vue?vue&type=template&id=5091dd13&scoped=true&"
import script from "./DeliverAddGoodTable.vue?vue&type=script&lang=ts&"
export * from "./DeliverAddGoodTable.vue?vue&type=script&lang=ts&"
import style0 from "./DeliverAddGoodTable.vue?vue&type=style&index=0&id=5091dd13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5091dd13",
  null
  
)

export default component.exports